import React, { FC } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Path } from 'routes';
import { useApp } from 'context/AppContext';
import { ReactComponent as IconLogo } from 'logo.svg';
import { ReactComponent as IconMenu } from 'assets/icons/header-menu.svg';
import { ReactComponent as IconBack } from 'assets/icons/header-back.svg';
import {
    Component, Logo, Menu, Nav, Title,
} from './Header.styled';

export const Header:FC = () => {
    const { title, menu } = useApp();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    if (pathname === Path.private.registration) return null;
    // That's temporary decision for keeping default header place, cause if it isn't markup is going to be broken
    if (pathname.includes('chat')) return <Component />;

    return (
        <Component>
            { pathname === Path.public.main
                ? (
                    <>
                        <Logo>
                            <Link to={Path.public.main}>
                                <IconLogo />
                            </Link>
                        </Logo>
                        <Title>{ title }</Title>
                    </>
                )
                : (
                    <Nav onClick={() => navigate(-1)}>
                        <IconBack />
                        <Title>{ title }</Title>
                    </Nav>
                )}
            {
                pathname !== Path.private.registration
                && (
                    <Menu isActiveMenu={menu.active}>
                        <span>18+</span>
                        <button name="menu" onClick={menu.toggle} type="button">
                            <IconMenu />
                        </button>
                    </Menu>
                )
            }
        </Component>
    );
};
